import { render, staticRenderFns } from "./QuestionIcon.vue?vue&type=template&id=6797c639&"
import script from "./QuestionIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports